import InlineEditors from '../../controllers/inlineEditors';

export default instance => {
  instance.ext.inlineEditors.attachEvent('onEditStart', ({ id, columnName }) => InlineEditors.onEditStart(id, columnName));
};
